import { Card, Fade, Icon, Modal, Tab, Tabs, Tooltip } from "@mui/material";
import chromeLogo from "assets/images/icons/chrome.png";
import safariLogo from "assets/images/icons/safari.png";
import chrome1 from "assets/images/installGuide/chrome/chrome1.png";
import chrome2 from "assets/images/installGuide/chrome/chrome2.png";
import chrome3 from "assets/images/installGuide/chrome/chrome3.png";
import safari1 from "assets/images/installGuide/safari/safari1.png";
import safari2 from "assets/images/installGuide/safari/safari2.png";
import safari3 from "assets/images/installGuide/safari/safari3.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  overflowY: "auto",
  p: 3,
  transition: "width 0.5s",
  width: { xs: "90%", sm: "50%", xxl: "30%" },
};

export default function ModalInstallApp({ open, handleClose }) {
  const [selectedBrowser, setSelectedBrowser] = useState("Safari");

  const instructions = {
    Safari: [
      { text: "Presiona el botón compartir (📤).", image: safari1 },
      { text: "Selecciona 'Añadir a la pantalla de inicio'.", image: safari2 },
      { text: "Pulsa añadir.", image: safari3 },
    ],
    Chrome: [
      {
        text: "Presiona el botón de menú (tres puntos en la esquina superior derecha).",
        image: chrome1,
      },
      { text: "Selecciona 'Añadir a la pantalla de inicio'.", image: chrome2 },
      { text: "Pulsa añadir.", image: chrome3 },
    ],
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" flexDirection="column" gap={2}>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Instrucciones para instalar la APP</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox>
              <Tabs
                value={selectedBrowser}
                name="selectedBrowser"
                onChange={(e, value) => {
                  setSelectedBrowser(value);
                }}
              >
                <Tab
                  label={
                    <SoftBox display="flex" alignItems="center" gap={1}>
                      <SoftBox component="img" src={safariLogo} alt="Safari Logo" width="1rem" />
                      <SoftTypography
                        variant="h6"
                        fontWeight={selectedBrowser === "Safari" ? "bold" : "regular"}
                      >
                        Safari
                      </SoftTypography>
                    </SoftBox>
                  }
                  value={"Safari"}
                />
                <Tab
                  label={
                    <SoftBox display="flex" alignItems="center" gap={1}>
                      <SoftBox component="img" src={chromeLogo} alt="Chrome Logo" width="1rem" />
                      <SoftTypography
                        variant="h6"
                        fontWeight={selectedBrowser === "Chrome" ? "bold" : "regular"}
                      >
                        Chrome
                      </SoftTypography>
                    </SoftBox>
                  }
                  value={"Chrome"}
                />
              </Tabs>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" gap={2}>
              {instructions[selectedBrowser].map((step, index) => (
                <SoftBox key={index}>
                  <SoftBox display="flex" gap={1}>
                    <SoftTypography variant="h6" color="primary">
                      {index + 1}.
                    </SoftTypography>
                    <SoftTypography variant="h6">{step.text}</SoftTypography>
                  </SoftBox>
                  <SoftBox display="flex" justifyContent="center" alignItems="center">
                    <SoftBox
                      component="img"
                      src={step.image}
                      alt={`Paso ${index + 1}`}
                      width="50%"
                      mt={2}
                    />
                  </SoftBox>
                </SoftBox>
              ))}
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalInstallApp.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
